import { OrderedMap } from 'immutable';
import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import getEarlyRequest from 'automation-ui-action-features/utils/getEarlyRequest';
import { useContext } from 'react';
// @ts-expect-error Untyped dependency
import { getCreatableObjectTypes } from 'crm-properties-common-lib/utils/getCreatableObjectTypes';
import { Set as ImmutableSet } from 'immutable';
import AuthContext from 'automation-ui-core/context/AuthContext';
import formatObjectTypesResponse from 'automation-ui-references/object-type-properties/formatObjectTypesResponse';
import { jsx as _jsx } from "react/jsx-runtime";
const earlyRequestName = 'object-types';
export const GET_ALL_OBJECT_TYPES = registerQuery({
  fieldName: 'actionFeatures_allObjectTypes',
  fetcher: () => getEarlyRequest({
    key: earlyRequestName,
    defaultRequestFn: () => http.get(`inbounddb-meta/v1/object-types/for-portal`)
  }).then(formatObjectTypesResponse)
});
export const useObjectTypeDefinition = objectTypeId => {
  const {
    data
  } = useQuery(GET_ALL_OBJECT_TYPES);
  return objectTypeId ? data === null || data === void 0 ? void 0 : data.actionFeatures_allObjectTypes.get(objectTypeId) : undefined;
};
export const queryAllObjectTypes = WrappedComponent => props => {
  const {
    data,
    loading
  } = useQuery(GET_ALL_OBJECT_TYPES);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    allObjectTypes: (data === null || data === void 0 ? void 0 : data.actionFeatures_allObjectTypes) || OrderedMap(),
    allObjectTypesLoading: loading
  }));
};
export const generateObjectTypeIdsSupportingCustomProperties = (scopes, data) => {
  return data ? getCreatableObjectTypes({
    scopes,
    objectTypeData: data.actionFeatures_allObjectTypes
  }).keySeq().toSet() : ImmutableSet();
};
export const wireObjectTypeSupportsCustomProperties = WrappedComponent => props => {
  const {
    user
  } = useContext(AuthContext);
  const {
    scopes
  } = user;
  const result = useQuery(GET_ALL_OBJECT_TYPES);
  const data = result.data;
  const objectTypeIdsSupportingCustomProperties = useMemo(() => generateObjectTypeIdsSupportingCustomProperties(scopes, data), [scopes, data]);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    supportsCustomProperties: objectTypeId => objectTypeIdsSupportingCustomProperties.has(objectTypeId)
  }));
};